import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import he from 'he';

import { routes } from '../../../../routes';

import Card from '../../../../components/Card';

const mapStore = ({ user }) => ({ trainings: user.userTrainings });

const propTypes = {
  trainings: PropTypes.array,
};

const Trainings = ({ trainings }) => (
  <div>
    <div className="row">
      <div className="col">
        <Card training>
          <Card.Header compact registration>
            Trainings
          </Card.Header>
          <Card.Body>
            {trainings.length ? (
              'Below are your trainings. Select one to view more information'
            ) : (
              <Fragment>
                You don't have any trainings yet, but you can register for one{' '}
                <Link to={routes.certificationsAndTraining.register.root}>here</Link>
              </Fragment>
            )}
          </Card.Body>
        </Card>
        <div className="row mt-4">
          <div className="col">
            <div className="card-deck">
              {trainings &&
                trainings.map((training) => {
                  return (
                    <Card key={training.id} training className="mb-4">
                      <Card.Header divider>{he.decode(training.name)}</Card.Header>
                      <Card.Body>
                        <p>
                          <strong>Badge:</strong> <a href={training.accredibleUrl}>View</a>
                        </p>
                      </Card.Body>
                    </Card>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Trainings.propTypes = propTypes;

export default connect(mapStore)(Trainings);
